import React, { useEffect, useState } from "react";
import towing from "../../assets/images/towing.svg";
import Whitelogo from "../../assets/images/White-logo.svg";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { login } from "../../redux/action/auth";
import { ToastContainer } from "react-toastify";
import hideIcon from "../../assets/images/hide.png";
import ViewIcon from "../../assets/images/view.png";

const Login = () => {
  const dispatch = useDispatch();
  const [activeLoader, setActiveLoader] = useState(false);
  const [btnStatus, setBtnStatus] = useState("");
  const [showPassword, setShowPassword] = useState(false); // New state variable to toggle password visibility
  const currentYear = new Date().getFullYear();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    position: "user_admin",
  });

  // remember
  const decodeData = (str) => decodeURIComponent(escape(atob(str)));

  const [remember, setRemember] = useState(true);
  const handleRemember = () => setRemember((prevRemember) => !prevRemember);
  useEffect(() => {
    const encodeEmail = localStorage.getItem("rememberEmail");
    const remember = localStorage.getItem("remember");
    const encodePassword = localStorage.getItem("rememberPassword");
    if (encodeEmail && encodePassword) {
      const decodeEmail = decodeData(encodeEmail);
      const decodePassword = decodeData(encodePassword);
      setFormData({
        ...formData,
        email: decodeEmail,
        password: decodePassword,
      });
    }
    if (remember) setRemember(true);
    else setRemember(false);
  }, []);

  // remember

  const { email, password } = formData;
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handler = async () => {
    setActiveLoader(true);
    setBtnStatus("disabled");
    const success = await dispatch(
      login({ email: email, password: password, remember: remember }),
    );
    if (!success) {
      setActiveLoader(false);
      setBtnStatus("");
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div
            className="d-flex flex-column flex-lg-row-auto bg-primary w-xl-600px positon-xl-relative banner-height"
            style={{ height: "100vh" }}
          >
            <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                <a href="index.html" className="py-9 pt-lg-20">
                  <img alt="Logo" src={Whitelogo} className="h-40px" />
                </a>
                <h1 className="fw-bolder text-white fs-2qx pb-5 pb-md-10">
                  Welcome to Roadside
                </h1>
                <p className="fw-bold fs-2 text-white">
                  Emergency Roadside Assistance for Every Bahamas Motorist
                </p>
              </div>
              <div
                className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
                style={{
                  backgroundImage: `url(${towing})`,
                }}
              ></div>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row-fluid py-10">
            <div className="d-flex flex-center flex-column flex-column-fluid">
              <div className="w-lg-500px p-10 p-lg-15 mx-auto w-100">
                <form className="form w-100" noValidate="noValidate">
                  <div className="text-center mb-10">
                    <h1 className="text-dark mb-3">Log In</h1>
                  </div>
                  <div className="fv-row mb-10">
                    <label className="form-label fs-6 fw-bolder text-dark">
                      <span className="required">Email</span>
                    </label>
                    <input
                      className="form-control form-control-lg form-control-solid"
                      type="text"
                      name="email"
                      value={email}
                      onChange={(e) => onChange(e)}
                      autoComplete="email"
                    />
                  </div>
                  <div className="fv-row mb-4">
                    <div className="d-flex flex-stack mb-2">
                      <label className="form-label fw-bolder text-dark fs-6 mb-0">
                        <span className="required">Password</span>
                      </label>
                      <Link
                        to="/password-reset"
                        className="link-primary fs-6 fw-bolder"
                      >
                        Forgot Password ?
                      </Link>
                    </div>
                    <div className="input-group">
                      <input
                        className="form-control form-control-lg form-control-solid"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={onChange}
                        autoComplete="current-password"
                      />
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={togglePasswordVisibility}
                      >
                        <img
                          onClick={togglePasswordVisibility}
                          className="membership-badge ms-2"
                          src={showPassword ? ViewIcon : hideIcon}
                          alt="tow"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="d-flex form-group form-check mb-10 align-items-center gap-2">
                    <input
                      type="checkbox"
                      className="form-check-input remember-check"
                      id="exampleCheck1"
                      onChange={handleRemember}
                      checked={remember}
                    />
                    <label
                      className="form-label fw-bolder text-dark fs-6 mb-0"
                      htmlFor="exampleCheck1"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="text-center">
                    <button
                      onClick={handler}
                      className={`btn btn-lg btn-primary w-100 mb-5 ${
                        email === "" || password === "" ? "disabled" : btnStatus
                      }`}
                      type="button"
                    >
                      {activeLoader === true ? (
                        <div className="spinner-border w-80" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <span className="indicator-label">Continue</span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
              <div className="d-flex flex-center fw-bold fs-6">
                <p>{currentYear} © Copyright All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default connect(null, { login })(Login);
